import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { BiExport, BiImport } from "react-icons/bi";
import { retailerService } from "../../Services";
import Loader from "../../Components/Loader";
import { MdEdit } from "react-icons/md";
import { toast } from "react-toastify";
import { RateRequestProfile } from "./RateRequestProfile";

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

const formatPlanDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

const planDurationLabel = (start, end) => {
  if (!start || !end) return "—";
  const days = Math.round((new Date(end) - new Date(start)) / 86400000);
  if (!Number.isFinite(days) || days <= 0) return "—";
  if (days >= 300) return "Yearly";
  if (days >= 80) return "Quarterly";
  if (days >= 20) return "Monthly";
  return `${days} days`;
};

const addonLabel = (details) => {
  const addons = Array.isArray(details?.addon_details) ? details.addon_details : [];
  if (!addons.length) return "No add-ons";
  return addons
    .map((addon) => `${addon.name || "Add-on"}${addon.duration ? ` (${addon.duration})` : ""}`)
    .join(", ");
};

const money = (value) => Number(value || 0).toFixed(2);
export function RetailerDetails() {
  const history = useHistory();
  let param = new URLSearchParams(history.location.search);
  let retailer_id = param.get("id");

  const [loader, setLoader] = useState(true);
  const [details, setDetails] = useState({});
  const [storeList, setStoreList] = useState([]);
  const [retailerDutyTaxHeaders, setRetailerDutyTaxHeaders] = useState([]);
  const [retailerDutyTax, setRetailerDutyTax] = useState([]);
  const [rateProfile, setRateProfile] = useState(null);

  useEffect(() => {
    getRetailerDetails();
    getStoreList();
    // eslint-disable-next-line
  }, []);

  const getRetailerDetails = () => {
    setLoader(true);
    const postData = {
      id: param.get("id"),
    };
    retailerService.getRetailerDetails(postData).then((res) => {
      if (res.status) {
        const row = res.data[0] || {};
        setDetails({
          type: row.type,
          tier: row.tier,
          profit_margin: row.profit_margin,
          retailer_name: row.retailer_name,
          retailer_type: row.retailer_type,
          contact_name: row.contact_name,
          phone_number: row.phone_number,
          retailer_email: row.retailer_email,
          referral_token: row.referral_token,
          retailer_token: row.retailer_token,
          total_discount: row.total_discount,
          customer_discount: row.customer_discount,
          store_discount: row.store_discount,
          subscription_plan: row.subscription_plan,
          subscription_status: row.subscription_status,
          subscription_start_date: row.subscription_start_date,
          subscription_end_date: row.subscription_end_date,
          addon_details: row.addon_details || [],
          purchased_addons: row.purchased_addons || [],
          extra_user_seats: row.extra_user_seats || 0,
          saas_payments: Array.isArray(row.saas_payments) ? row.saas_payments : [],
        });
        setRateProfile({
          rate_approval_status: row.rate_approval_status || "pending",
          rate_request_data: row.rate_request_data || null,
          rate_request_history: row.rate_request_history || [],
          rate_admin_message: row.rate_admin_message || null,
          rate_rejected_reason: row.rate_rejected_reason || null,
          rate_approved_at: row.rate_approved_at || null,
        });
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };
  const getStoreList = () => {
    setLoader(true);
    let listData = {
      id: retailer_id,
    };
    retailerService.getStoreData(listData).then((res) => {
      if (res.status) {
        setStoreList(res.data);
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const getRetailerDutyTaxesList = () => {
    setLoader(true);
    let listData = { retailer_id: retailer_id };
    retailerService.getRetailerDutyTax(listData).then((res) => {
      if (res.status) {
        let data = res.data;
        let sheet_data = [["Hsn Code"], [""]];
        for (let i = 0; i < data.length; i++) {
          sheet_data[0].push(data[i].country_name);
          sheet_data[0].push("");
          sheet_data[1].push("Duty %");
          sheet_data[1].push("Tax %");
        }
        let hsnCodes = Array.from(
          new Set(
            data.flatMap((item) => item.duty_tax.map((dt) => dt.hsn_code))
          )
        );

        hsnCodes.forEach((hsnCode) => {
          let row = [hsnCode];
          data.forEach((country) => {
            let dutyTax = country.duty_tax.find(
              (dt) => dt.hsn_code === hsnCode
            );
            row.push(dutyTax ? dutyTax.duty : "", dutyTax ? dutyTax.tax : "");
          });
          sheet_data.push(row);
        });
        setRetailerDutyTax(sheet_data.slice(2));
        setRetailerDutyTaxHeaders(sheet_data.slice(0, 2));
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  useEffect(() => {
    getRetailerDutyTaxesList();
  }, []);

  const onClickImport = (e) => {
    let formData = new FormData();
    formData.append("csv_file", e.target.files[0]);
    formData.append("retailer", retailer_id);
    retailerService.importRetailerDutyTax(formData).then((res) => {
      if (res.status) {
        getRetailerDutyTaxesList()
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  const onClickExport = () => {
    let params = { retailer: retailer_id };
    retailerService.exportRetailerDutyTax(params).then((res) => {
      if (res.status) {
        window.location.href = REACT_APP_API_BASEURL + "/" + res.data;
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  console.log(details, "details");

  return (
    <div className="container-fluid">
      <div className="white_box h-100">
        <div className="row">
          <div className="col-md-12 mb-4">
            <div className="row">
              <div className="row">
                <div className="col-md-12">
                  <div className="row mb-3">
                    <div className="col-lg-5 col-md-4 mb-6">
                      <div className="card p-3 h-100">
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Type - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.type}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Retailer Name - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.retailer_name}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Type of Retailer - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.retailer_type}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Contact Person - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.contact_name}
                          </div>
                        </div>

                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Contact No. - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.phone_number}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Email - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.retailer_email}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Referral Code - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.referral_token}
                          </div>
                        </div>

                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Retailer Token - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.retailer_token}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Tier - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.tier}
                          </div>
                        </div>
                        {
                          details && details.type === "marketplace" && 
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Profit Margin - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.profit_margin && details.profit_margin.split("_").join(" ")}
                          </div>
                        </div> ||
                        <>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Total Discount - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.total_discount}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Customer Discount - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.customer_discount}
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-4">
                            <b>Store Discount - </b>
                          </div>
                          <div className="mb-3 col-8">
                            {details && details.store_discount}
                          </div>
                        </div>
                        </>
                        }
                      </div>
                    </div>

                    {details?.subscription_plan && (
                      <div className="col-lg-12 mt-4">
                        <div className="card p-3 h-100">
                          <h5 className="mb-3">Plan Details</h5>
                          <div className="row">
                            <div className="mb-3 col-md-3">
                              <b>Plan</b>
                              <div>{details.subscription_plan}</div>
                            </div>
                            <div className="mb-3 col-md-3">
                              <b>Subscription Status</b>
                              <div>{details.subscription_status || "—"}</div>
                            </div>
                            <div className="mb-3 col-md-3">
                              <b>Duration</b>
                              <div>
                                {planDurationLabel(details.subscription_start_date, details.subscription_end_date)}
                                <div className="text-muted" style={{ fontSize: "0.85rem" }}>
                                  {formatPlanDate(details.subscription_start_date)} – {formatPlanDate(details.subscription_end_date)}
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 col-md-3">
                              <b>Add-ons</b>
                              <div>{addonLabel(details)}</div>
                            </div>
                          </div>
                          <h6 className="mb-3">Payments</h6>
                          {Array.isArray(details.saas_payments) && details.saas_payments.length > 0 ? (
                            <div className="table-responsive">
                              <table className="table table-bordered table-sm mb-0">
                                <thead className="table-light">
                                  <tr>
                                    <th>Invoice</th>
                                    <th>Paid on</th>
                                    <th>Type</th>
                                    <th>Breakdown</th>
                                    <th>Subtotal</th>
                                    <th>VAT</th>
                                    <th>Total</th>
                                    <th>AED charged</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {details.saas_payments.map((pay) => (
                                    <tr key={pay._id || pay.invoice_no}>
                                      <td>{pay.invoice_no || "—"}</td>
                                      <td>{formatPlanDate(pay.paid_at)}</td>
                                      <td>{pay.kind_label || "—"}</td>
                                      <td style={{ whiteSpace: "normal", minWidth: "180px" }}>
                                        {(pay.lines || []).map((line, lineIndex) => (
                                          <div key={lineIndex}>{line.label}: USD {money(line.amount)}</div>
                                        ))}
                                        {pay.charge_id ? <div className="text-muted">Charge {pay.charge_id}</div> : null}
                                      </td>
                                      <td>USD {money(pay.subtotal)}</td>
                                      <td>USD {money(pay.vat)}</td>
                                      <td>USD {money(pay.total)}</td>
                                      <td>AED {money(pay.aed_amount)}</td>
                                      <td>{pay.status || "Paid"}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="text-muted">No payments recorded.</div>
                          )}
                        </div>
                      </div>
                    )}

                    {
                      details && details.type !== "marketplace" &&
                    <div className="col-lg-7 col-md-4 mb-6">
                      <div className="card p-3 h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-between mb-3">
                            <div>
                            </div>
                            <button
                              className="btn btn-primary w-sm waves-effect waves-light"
                              onClick={() =>
                                history.push("/add-store?id=" + retailer_id)
                              }
                            >
                              Add Store
                            </button>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                              <thead className="table-light">
                                <tr>
                                  <th> Store Name</th>
                                  <th>Address</th>
                                  <th>Contact</th>
                                  <th>email</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {storeList.length > 0 &&
                                  storeList.map((item, key) => {
                                    return (
                                      <tr key={item._id || key}>
                                        <td>{item.store_name}</td>
                                        <td>{item.address}</td>
                                        <td>{item.phone_number}</td>
                                        <td>{item.store_email}</td>
                                        <td>
                                          <MdEdit
                                            className="pointer"
                                            onClick={() =>
                                              history.push(
                                                "/edit-store?id=" + item._id,
                                                item
                                              )
                                            }
                                            color="#0323fe"
                                            size="25px"
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    }

                    {/* Rate Approval Profile — all requests */}
                    <div className="col-lg-12 mt-4">
                      <RateRequestProfile
                        item={rateProfile}
                        title="Rate Approval Profile"
                      />
                    </div>

                    {/* retailer duty tax  */}
                    {
                      details && details.type !== "marketplace" &&
                    <div className="col-lg-12 col-md-4 mt-4">
                      <div className="card p-2 h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-between mb-3">
                            <div className="fs-5 d-flex align-items-center  fw-bold">
                              Retailer duty and taxes
                            </div>
                            <div className="d-flex justify-content-end mb-3">
                              <input
                                type="file"
                                id="upload"
                                accept=".csv, .xlsx, .xls"
                                hidden
                                onChange={(e) => onClickImport(e)}
                              />
                              <label
                                for="upload"
                                className="btn btn-danger waves-effect waves-light mx-1 my-0"
                              >
                                <BiExport className="me-1 fs-5" />
                                Upload file
                              </label>
                              <div>
                                <button
                                  className="btn btn-success waves-effect waves-light mx-1 my-0"
                                  onClick={() => onClickExport()}
                                >
                                  <BiImport className="me-1 fs-5" />
                                  Download file
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="table-responsive">
                            {retailerDutyTaxHeaders && Array.isArray(retailerDutyTaxHeaders) && retailerDutyTaxHeaders.length > 0 
                            && retailerDutyTax && Array.isArray(retailerDutyTax) && retailerDutyTax.length>0 ? (
                              <table className="table table-centered table-nowrap mb-0 border text-center">
                                <thead className="table-light">
                                  {retailerDutyTaxHeaders.map((itm, index) => (
                                    <tr key={index}>
                                      {itm.map((item, i) => {
                                        if (i === 0 && index === 0) {
                                          return (
                                            <th rowSpan={2} key={i}>
                                              {item || "-"}
                                            </th>
                                          );
                                        } else if (index === 0) {
                                          if (item) {
                                            return (
                                              <th colSpan={2} key={i}>
                                                {item || "-"}
                                              </th>
                                            );
                                          }
                                          else{
                                            return null
                                          }
                                        } else {
                                          if (item) {
                                            return (
                                              <th key={i}>{item || "-"}</th>
                                            );
                                          }else{
                                            return null
                                          }
                                        }
                                      })}
                                    </tr>
                                  ))}
                                </thead>
                                <tbody>
                                  {retailerDutyTax.map((itm, index) => (
                                    <tr key={index}>
                                      {itm.map((item, i) => (
                                        <td key={i}>{item || "-"}</td>
                                      ))}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <div className="w-10 text-center mt-2">
                                Data Not Available
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader isShow={loader} />
    </div>
  );
}
